import { render, staticRenderFns } from "./EditMultiLabelDialog.vue?vue&type=template&id=a329fe1c&scoped=true"
import script from "./EditMultiLabelDialog.vue?vue&type=script&lang=js"
export * from "./EditMultiLabelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a329fe1c",
  null
  
)

export default component.exports